import { HttpInterceptorFn } from '@angular/common/http';
import { AuthTokenService } from '../auth/auth-token.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoggerService } from '../shared/logger.service';
import { catchError, finalize, switchMap, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { MySingletonService } from '../api/my-singleton.service';

export const bearerRefreshInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);
  let router = inject(Router);
  let authTokenService = inject(AuthTokenService);
  let authService = inject(AuthService);
  let mySingleTon = inject(MySingletonService);
  if (mySingleTon.isRefreshing) {
    return next(req);
  }
  const bearerToken = authTokenService.getToken();
  // logger.debug(`bearerRefreshInterceptopr:token: `, bearerToken);
  if (bearerToken && bearerToken !== 'undefined') {
    const clonedReq = req.clone({
      withCredentials: true,
      headers: req.headers.append('Authorization', `Bearer ${bearerToken}`),
    })

    return next(clonedReq).pipe(
      catchError(errorData => {
        logger.error(`catchError: `, errorData);
        if (errorData.status === 401 || errorData.status === 403) {
          mySingleTon.refreshingToken = true;
          return authService.refreshToken()
            .pipe(
              switchMap((data: any) => {
                logger.debug(`switchMap:data: `, data);
                authTokenService.setToken(data.token);
                let tryAgain = req.clone({
                  withCredentials: true,
                  headers: req.headers.append('Authorization', `Bearer ${authTokenService.getToken()}`),
                })
                return next(tryAgain);
              }),
              catchError(errorData => {
                logger.error(`refreshToken:error:`, errorData);
                authTokenService.removeToken();
                router.navigateByUrl('/login');
                return next(req);
                // return throwError(errorData);
              }),
              finalize(() => {
                // logger.debug(`finalize...`);
                mySingleTon.refreshingToken = false;
              })
            )
        }
        return throwError(() => errorData)
      }),
      finalize(() => {
        // logger.debug(`next:pipe:finalize...`);
        mySingleTon.refreshingToken = false;
      }));
  } else {
    // logger.debug('bearerInterceptor:no token... ');
    return next(req);
  }
};
